<template>
  <div class="example-component border p-3">
    <h2>This is an <strong>example Vue component</strong>.</h2>
    <div class="mb-3">
      <p>My prop "message" value is: {{ message }}</p>
    </div>
    <div class="mb-3">
      <p>My slot "content" is:</p>
      <slot name="content">
        Default content slot value
      </slot>
    </div>
    <div class="mb-3">
      <p>Clicking this button increments the data value "count"</p>
      <button class="btn btn-primary" @click="incrementCount">Click me</button>
      <p>Button click count: {{ count }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      message: String
    },
    data() {
      return {
        count: 0
      }
    },
    methods: {
      incrementCount() {
        this.count++;
      }
    }
  }
</script>